<template>
  <v-container fluid class="container-view">
    <v-row class="pt-5">
      <v-col
        cols="12"
        md="8"
        lg="4"
        sm="8"
        xl="4"
        offset-xl="0"
        offset-lg="0"
        offset-sm="2"
        offset-md="2"
        :class="{ 'total-points-sheet': isInCarousel }"
      >
        <div v-if="!isInCarousel" class="div-sheet-points">
          <v-sheet
            elevation="8"
            class="d-flex align-center justify-center flex-wrap text-center"
            height="200"
            width="250"
          >
            <div>
              <h2
                class="text-h3 font-weight-black text-color font-futura"
              >
                {{
                  this.totalToShow == 0 || this.totalToShow < 0
                    ? 0
                    : Math.round(this.totalToShow).toLocaleString("fr-FR")
                }}
              </h2>

              <div
                class="text-body-2 mt-2 font-egyptienne"
              >
                {{
                  this.$t("total-pts-year", {
                    year: currentYear,
                  })
                }}
              </div>
            </div>
          </v-sheet>
        </div>
        <div
          v-else
          class="d-flex align-center justify-center flex-wrap text-center"
        >
          <v-sheet
            elevation="8"
            class="d-flex align-center justify-center flex-wrap text-center"
            height="200"
            width="250"
          >
            <div>
              <h2
                class="text-h2 font-weight-black text-color font-futura"
              >
                {{
                  this.totalToShow == 0 || this.totalToShow < 0
                    ? 0
                    : Math.round(this.totalToShow).toLocaleString("fr-FR")
                }}
              </h2>

              <div
                class="mt-2 font-egyptienne-subtitle"
              >
                {{
                  this.$t("total-pts-year", {
                    year: currentYear,
                  })
                }}
              </div>
            </div>
          </v-sheet>
        </div>
      </v-col>

      <v-col
        cols="12"
        md="8"
        lg="8"
        sm="12"
        xl="8"
        offset-xl="0"
        offset-lg="0"
        offset-sm="0"
        offset-md="2"
      >
        <div>
          <v-sheet
            class="first-sheet-carousel-command d-flex align-center"
            elevation="8"
            height="90"
            width="99%"
          >
            <v-row>
              <v-col
                cols="2"
                class="pr-0 d-flex align-center justify-center flex-wrap text-center"
              >
                <h2 class="text-h6 font-futura">
                  {{ previousYear }}
                </h2>
              </v-col>
              <v-divider
                :thickness="2"
                class="border-opacity-100 divider-height"
                vertical
              ></v-divider>
              <v-col>
                <h2
                  class="text-h5 text-center font-egyptienne-subtitle"
                >
                  Statut
                  {{
                    this.stats.statusPastYear < 0
                      ? 0
                      : this.stats.statusPastYear
                  }}
                  -
                  {{
                    this.stats.totalPastYear == 0 ||
                    this.stats.totalPastYear < 0
                      ? 0
                      : Math.round(this.stats.totalPastYear).toLocaleString(
                          "fr-FR",
                        )
                  }}€ ventes {{ previousYear }}
                </h2>
              </v-col>
            </v-row>
          </v-sheet>
        </div>
        <div>
          <v-sheet
            class="second-sheet-carousel-command d-flex align-center"
            elevation="8"
            height="90"
            width="99%"
          >
            <v-row>
              <v-col
                cols="2"
                class="pr-0 d-flex align-center justify-center flex-wrap text-center"
              >
                <h2 class="text-h6 font-futura">
                  {{ currentYear }}
                </h2>
              </v-col>
              <v-divider
                :thickness="2"
                length="60"
                class="border-opacity-100 divider-center"
                vertical
              ></v-divider>
              <v-col>
                <h2
                  class="text-h6 text-center font-egyptienne-subtitle"
                >
                  Statut
                  {{
                    this.stats.customer.manualStatutCurrentYear != null &&
                    this.stats.customer.manualStatutCurrentYear.number > 0
                      ? this.stats.customer.manualStatutCurrentYear.number
                      : this.stats.customer.status.number < 0
                      ? 0
                      : this.stats.customer.status.number
                  }}
                  -
                  {{
                    this.stats.totalCurrentYear == 0 ||
                    this.stats.totalCurrentYear < 0
                      ? 0
                      : Math.round(this.stats.totalCurrentYear).toLocaleString(
                          "fr-FR",
                        )
                  }}€ ventes
                  {{ currentYear }}
                </h2>
                <h5
                  class="text-caption font-egyptienne-subtitle"
                >
                  {{ this.$t("projection") }}
                </h5>
                <v-row
                  class="d-flex align-center justify-center flex-wrap text-center"
                >
                  <v-col cols="11" class="pt-0 pb-0">
                    <v-slider
                      v-model="statusProgress"
                      :min="0"
                      :max="4"
                      :ticks="this.tickLabelsStatus"
                      color="#ffb500"
                      show-ticks="always"
                      tick-size="4"
                    >
                      <template v-slot:tick-label="{ tick }">
                        <p
                          class="text-caption font-egyptienne-subtitle"
                        >
                          {{ tick.label }}
                        </p>
                      </template>
                    </v-slider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-sheet>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" lg="3" sm="6" xl="3" class="pl-0 pr-0">
        <v-row
          class="px-0 py-0 mx-0 my-0 d-flex align-center justify-center flex-wrap text-center"
        >
          <v-col cols="11" class="px-0 py-0 mx-0 my-0">
            <div
              class="d-flex align-center justify-center flex-wrap text-center"
            >
              <div>
                <h2
                  class="text-h4 font-weight-black text-color font-futura"
                >
                  {{
                    this.stats.capitalPoints == 0 ||
                    this.stats.capitalPoints < 0
                      ? 0
                      : Math.round(this.stats.capitalPoints).toLocaleString(
                          "fr-FR",
                        )
                  }}
                </h2>

                <div
                  class="mt-2 font-egyptienne-subtitle"
                >
                  {{ this.$t("points") }} {{ currentYear }}
                  {{ this.$t("capital") }}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="6" lg="3" sm="6" xl="3" class="pl-0 pr-0">
        <v-row
          class="px-0 py-0 mx-0 my-0 d-flex align-center justify-center flex-wrap text-center"
        >
          <v-divider
            :thickness="1"
            class="border-opacity-50"
            vertical
          ></v-divider>
          <v-col cols="11" class="px-0 py-0 mx-0 my-0">
            <div
              class="d-flex align-center justify-center flex-wrap text-center"
            >
              <div>
                <h2
                  class="text-h4 font-weight-black text-color font-futura"
                >
                  {{
                    this.stats.consommablePoints == 0 ||
                    this.stats.consommablePoints < 0
                      ? 0
                      : Math.round(this.stats.consommablePoints).toLocaleString(
                          "fr-FR",
                        )
                  }}
                </h2>

                <div
                  class="mt-2 font-egyptienne-subtitle"
                >
                  {{ this.$t("points") }} {{ currentYear }}
                  {{ this.$t("consommable") }}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="6" lg="3" sm="6" xl="3" class="pl-0 pr-0">
        <v-row
          class="px-0 py-0 mx-0 my-0 d-flex align-center justify-center flex-wrap text-center"
        >
          <v-divider
            :thickness="1"
            class="border-opacity-50"
            vertical
          ></v-divider>
          <v-col cols="11" class="px-0 py-0 mx-0 my-0">
            <div
              class="d-flex align-center justify-center flex-wrap text-center"
            >
              <div>
                <h2
                  class="text-h4 font-weight-black text-color font-futura"
                >
                  {{
                    this.stats.implantPoints == 0 ||
                    this.stats.implantPoints < 0
                      ? 0
                      : Math.round(this.stats.implantPoints).toLocaleString(
                          "fr-FR",
                        )
                  }}
                </h2>

                <div
                  class="mt-2 font-egyptienne-subtitle"
                >
                  {{ this.$t("points") }} {{ currentYear }}
                  {{ this.$t("implant") }}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="6" lg="3" sm="6" xl="3" class="pl-0 pr-0">
        <v-row
          class="px-0 py-0 mx-0 my-0 d-flex align-center justify-center flex-wrap text-center"
        >
          <v-divider
            :thickness="1"
            class="border-opacity-50"
            vertical
          ></v-divider>
          <v-col cols="11" class="px-0 py-0 mx-0 my-0">
            <div
              class="d-flex align-center justify-center flex-wrap text-center"
            >
              <div>
                <h2
                  class="text-h4 font-weight-black text-color font-futura"
                >
                  {{
                    this.stats.servicePoints == 0 ||
                    this.stats.servicePoints < 0
                      ? 0
                      : Math.round(this.stats.servicePoints).toLocaleString(
                          "fr-FR",
                        )
                  }}
                </h2>

                <div
                  class="mt-2 font-egyptienne-subtitle"
                >
                  {{ this.$t("points") }} {{ currentYear }}
                  {{ this.$t("services") }}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import points from "@/mixins/points";
import contractYear from "@/mixins/contractYear";

export default {
  name: "FirstCarouselItem",
  mixins: [points, contractYear],
  props: {
    isInCarousel: {
      type: Boolean,
      default: true,
    },
    contractInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      color: "indigo",
      slide: "First",
      tickLabels: {
        0: "Aucun Statut",
        500000: "Statut 1",
        800000: "Statut 2",
        1300000: "Statut 3",
        2300000: "Statut 4",
      },
    };
  },
  computed: {
    ...mapState({
      customer: (state) => state.users.selectedCustomer,
      stats: (state) => state.statsCustomer.statsCustomer,
    }),
    /**
     * Override du mixin contractYear pour gérer le cas spécial contractInfo
     */
    currentYear() {
      if (this.contractInfo && this.contractInfo.startDate) {
        return new Date(this.contractInfo.startDate).getFullYear();
      }

      const now = new Date();
      const currentYear = now.getFullYear();
      const month = now.getMonth() + 1;
      const day = now.getDate();

      if (month === 1 && day <= 15) {
        return currentYear - 1;
      }
      return currentYear;
    },
    totalToShow() {
      var consommable =
        this.$store.state.statsCustomer.statsCustomer.consommablePoints;
      var capital = this.$store.state.statsCustomer.statsCustomer.capitalPoints;
      var implant = this.$store.state.statsCustomer.statsCustomer.implantPoints;
      var service = this.$store.state.statsCustomer.statsCustomer.servicePoints;
      var total = consommable + capital + implant + service;
      return total;
    },

    tickLabelsStatus() {
      const isSmallScreen = this.$vuetify.display.mdAndDown; // sm (≤600px) ou plus petit
      return {
        0: isSmallScreen ? "Aucun" : "Aucun statut",
        1: isSmallScreen ? "St.1" : "Statut 1",
        2: isSmallScreen ? "St.2" : "Statut 2",
        3: isSmallScreen ? "St.3" : "Statut 3",
        4: isSmallScreen ? "St.4" : "Statut 4",
      };
    },

    statusProgress: {
      get() {
        var value = (
          this.$store.state.statsCustomer.statsCustomer.totalCurrentYear /
          1000000
        ).toFixed(2);
        this.scaleValue(value);
        return this.scaleValue(value);
      },
    },
  },
  methods: {
    scaleValue(value) {
      if (value < 0.5) {
        return 0; // Aucun statut
      } else if (value >= 0.5 && value < 0.8) {
        return 1; // Statut 1
      } else if (value >= 0.8 && value < 1.3) {
        return 2; // Statut 2
      } else if (value >= 1.3 && value < 2.2) {
        return 3; // Statut 3
      } else if (value >= 2.2) {
        return 4; // Statut 4
      } else {
        return 0;
      }
    },
  },
};
</script>

<style scoped>
.div-sheet-points {
  /* text-align: center; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.container-text-statut {
  text-align: center;
}

.first-sheet-carousel-command {
  margin-bottom: 20px;
  border-left: 4px solid #feb100;
  border-top-left-radius: 6px; /* Round the top-left corner */
  border-bottom-left-radius: 6px; /* Round the bottom-left corner */
}

.second-sheet-carousel-command {
  margin-top: 20px;
  border-left: 4px solid #feb100;
  border-top-left-radius: 6px; /* Round the top-left corner */
  border-bottom-left-radius: 6px; /* Round the bottom-left corner */
}

.total-points-sheet {
  padding-left: 50px;
}

.text-color {
  color: #feb100;
}

.divider-center {
  align-self: center;
}
</style>
